import React from 'react';
import PropTypes from 'prop-types';
import Modal from 'apex-web/lib/components/common/Modal/Modal';
import APLabelWithText from 'apex-web/lib/components/common/APLabelWithText';
import { getBEMClasses } from 'apex-web/lib/helpers/cssClassesHelper';
import { formatDateTime } from 'apex-web/lib/helpers/dateHelper';
import { buyValue } from 'apex-web/lib/constants/sendOrder/orderEntryFormConstants';
import { getOrderFee } from 'apex-web/lib/helpers/orderHelper';
import 'apex-web/lib/components/Retail/RetailBuySell/BuySellOrderConfirmationModal/BuySellConfirmationModalComponent.css';

const bemClasses = getBEMClasses('buy-sell-order-confirmation');

const getConfirmButtonText = (isBuySide, responseMessage) => {
  if (responseMessage) {
    return 'OK';
  }
  return isBuySide ? 'Confirm Buy Order' : 'Confirm Sell Order';
};

class BuySellConfirmationModalComponent extends React.Component {
  state = { submitting: false };

  placeOrder = () => {
    const { confirmReport, buySellForm } = this.props;
    this.setState({ submitting: true });
    confirmReport(buySellForm.values).then(
      () => {
        this.setState({ submitting: false });
      },
      () => {}
    );
  };

  shouldComponentUpdate(nextProps) {
    const { responseMessage: rm } = this.props.buySellForm.values;
    const { responseMessage: nrm } = nextProps.buySellForm.values;
    if (rm && nrm) {
      return false;
    }
    return true;
  }

  render() {
    const {
      buySellForm,
      isOpen,
      close,
      selectedInstrument,
      positions,
      price,
      quantity,
      finalQuantity,
      onClose,
      hideFees,
      displayPricePerUnit,
      pricePerUnit
    } = this.props;
    const { t } = this.context;
    const isBuySide = buySellForm.values.side === buyValue;
    const product = selectedInstrument.Product1Symbol;
    const responseMessage = buySellForm.values.responseMessage;

    const title = (
      <span className={bemClasses('modal-title')}>
        <span
          className={bemClasses('title-action', {
            buy: isBuySide,
            sell: !isBuySide
          })}>
          {isBuySide ? t('Buy') : t('Sell')}
        </span>
        <span className={bemClasses('title-product')}>
          {' '}
          {product}
        </span>
      </span>
    );

    return (
      <Modal
        isOpen={isOpen}
        title={title}
        close={() => {
          close();
          onClose();
        }}
        footer={{
          buttonText: t(getConfirmButtonText(isBuySide, responseMessage)),
          disabled: this.state.submitting,
          onClick: responseMessage
            ? () => {
                close();
                onClose();
              }
            : this.placeOrder,
          overrideClose: true
        }}
        customClass={bemClasses('modal')}>
        <div className={bemClasses()}>
          <h3 className={bemClasses('header')}>
            {responseMessage || t('Confirmation')}
          </h3>
          <APLabelWithText
            customClass={bemClasses('order-type')}
            label={t('Order Type')}
            text={t('Market Order')}
          />
          <APLabelWithText
            customClass={bemClasses()}
            label={
              isBuySide
                ? t('{product} to Buy', { product })
                : t('{product} to Sell', { product })
            }
            text={t(''.concat(quantity))}
          />
          <APLabelWithText
            customClass={bemClasses()}
            label={t('Total Transaction Cost')}
            text={t(
              ''.concat(
                selectedInstrument.Product2Symbol,
                ' ',
                price
              )
            )}
          />
          {displayPricePerUnit && (
            <APLabelWithText
              customClass={bemClasses()}
              label={t('Price Per Unit')}
              text={pricePerUnit}
            />
          )}
          {!hideFees && (
            <React.Fragment>
              <APLabelWithText
                customClass={bemClasses()}
                label={t('Fee')}
                text={t(''.concat(getOrderFee(buySellForm, positions)))}
              />
              <APLabelWithText
                customClass={bemClasses()}
                label={t('Final Quantity')}
                text={`${
                  isBuySide
                    ? selectedInstrument.Product1Symbol
                    : selectedInstrument.Product2Symbol
                } ${finalQuantity}`}
              />
            </React.Fragment>
          )}
          <APLabelWithText
            customClass={bemClasses()}
            label={t('Date')}
            text={formatDateTime(new Date())}
          />
        </div>
      </Modal>
    );
  }
}

BuySellConfirmationModalComponent.defaultProps = {
  displayPricePerUnit: false
};

BuySellConfirmationModalComponent.propTypes = {
  buySellForm: PropTypes.object.isRequired,
  close: PropTypes.func.isRequired,
  isOpen: PropTypes.bool.isRequired,
  confirmReport: PropTypes.func.isRequired,
  selectedInstrument: PropTypes.object.isRequired,
  positions: PropTypes.object.isRequired,
  price: PropTypes.oneOfType([
    PropTypes.number.isRequired,
    PropTypes.string.isRequired,
    PropTypes.object.isRequired
  ]),
  quantity: PropTypes.oneOfType([
    PropTypes.number.isRequired,
    PropTypes.string.isRequired
  ]),
  finalQuantity: PropTypes.oneOfType([PropTypes.number, PropTypes.object]),
  onClose: PropTypes.func.isRequired,
  displayPricePerUnit: PropTypes.bool.isRequired,
  pricePerUnit: PropTypes.string,
  hideFees: PropTypes.bool
};

BuySellConfirmationModalComponent.contextTypes = {
  t: PropTypes.func.isRequired
};

export default BuySellConfirmationModalComponent;
